/**
 *
 * @fileoverview AppModule
 *
 * @version 1.0
 *
 * @author Milan Gotera <milangotera@gmail.com>
 *
 */

import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { CriptoService } from '@core/services/cripto/cripto.service';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthenticationService } from './core/authentications/authentication.service';
import { GuardService } from './core/guards/guard.service';
import { HttpService } from './core/http/http.service';
import { routingServiceFactory } from './core/services/routing/routing.factory';
import { ROUTING_SERVICE } from './core/services/routing/routing.token';
import { DirectionsRoutingService } from './core/services/routing/strategies/directions-routing.service';
import { RoutesApiRoutingService } from './core/services/routing/strategies/routes-api-routing.service';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, HttpClientModule],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    AuthenticationService,
    GuardService,
    HttpService,
    CriptoService,
    DirectionsRoutingService,
    RoutesApiRoutingService,
    {
      provide: ROUTING_SERVICE,
      useFactory: routingServiceFactory,
      deps: [DirectionsRoutingService, RoutesApiRoutingService],
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
